import * as React from "react";

import CreateCompanyContainer from "../../containers/Companies/CreateCompanyContainer";

export const CompanyCreateScene: React.FC = (): JSX.Element => (
  <div>
    <CreateCompanyContainer />
  </div>
);
